export enum PaymentStatusEnumFR {
  CREE = 'CREE',
  PAYE = 'PAYE',
  RAPPROCHE = 'RAPPROCHE',
  ANNULE = 'ANNULE',
}

export enum PaymentStatusEnum {
  CREATED = 'CREATED',
  PAYED = 'PAYED',
  APPROACHED = 'APPROACHED',
  CANCELED = 'CANCELED',
}

export const translatePaymentStatus = (ps: PaymentStatusEnumFR): PaymentStatusEnum => {
  switch (ps) {
    case PaymentStatusEnumFR.CREE:
      return PaymentStatusEnum.CREATED;
    case PaymentStatusEnumFR.PAYE:
      return PaymentStatusEnum.PAYED;
    case PaymentStatusEnumFR.RAPPROCHE:
      return PaymentStatusEnum.APPROACHED;
    case PaymentStatusEnumFR.ANNULE:
      return PaymentStatusEnum.CANCELED;
  }
};
